export default {
  'meta': {
    'langName': 'ANGLAIS',
    'lang': 'English'
  },
  'title': 'PRODUCT RECALL ELECTRICAL SCOOTER SD500E OR MD500E BTWIN',
  'description': 'Hello,\n\nYou have purchased a BTWIN brand SD 500E or MD500E electric scooter and we thank you for your purchase.\n\nYour safety is our priority, please read the following information.\n\nDespite rigorous quality control procedures, we have identified a safety defect in the BTWIN brand SD500E and MD500E electric scooters. Intensive use can lead to the appearance of a crack at the junction of the frame and the stem. This defect can cause this junction to break, resulting in a risk of falling for the user.\n\nWe suggest you answer the following questions so that we can provide you with a safety solution for your product.\n\nWe apologize for any inconvenience caused and thank you for your trust.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'First, could you please confirm your email address and country of residence:\r'
  },
  'fields': {
    'country': 'Country',
    'address': 'Mail adress',
    'email': 'Mail adress',
    'phonePrefix': 'Telephone number code',
    'phone': 'Phone number',
    'validations': {
      'phoneOrEmail': 'Please provide at least an email address or a phone number.',
      'email': 'Please enter a valid mail adress',
      'phone': 'Please enter a valid phone number',
      'selectAddress': 'Please select a complete address from the list (street number, street name and city).',
      'incompleteAddress': 'The address must include a street number, street name and city. Type at least the number and street, then pick a suggestion.'
    },
    'firstName': 'Surname',
    'lastName': 'First name',
    'deliveryAddress': 'Shipping address for the package',
    'additionalAddress': 'Additional address details',
    'city': 'City',
    'zip': 'ZIP Code / Postal Code',
    'readConfirmation': 'I certify that my contact information is accurate, acknowledge having read the terms provided, and agree to respect it',
    'choose': 'Select',
    'required': 'This field is required',
    'deliveryAddressHelp': 'Enter your street number and name, then choose a complete address from the list.',
    'streetOnlyHint': 'Add a street number'
  },
  'ownerCheck': {
    'title': 'Are you still owner of one or more BTWIN SD500E and MD500E electric scooters?'
  },
  'yes': 'YES',
  'no': 'NO',
  'ownerChanged': {
    'title': 'Do you have the contact details of the current owner(s)?',
    'confirmation': 'Mr./Ms.,\n\nThank you for your participation in this quality initiative.\n\nWe apologize for the inconvenience and thank you for your trust.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Please indicate the quantity of BTWIN SD500E and MD500E electric scooters.',
    'descriptionSd500': 'Escooters SD500E',
    'descriptionEmd500e': 'Escooters MD500E',
    'modelNumberHelp': 'You can find the model number (SD500E or MD500E) underneath your scooter, as shown below.',
    'quantity': 'Quantity',
    'confirmation': 'Thank you for filling out this form. Your request has been successfully registered.\n\nWe will inform you within a maximum of 20 days of the date from which you can carry out the repair.\n\nHave a great day,\n\nDECATHLON'
  },
  'repair': {
    'title': 'Repair carried out by yourself',
    'description': 'We ask you to stop using it.\n\nA repair kit and instructions will be sent to your home so that you can secure your scooter. This kit will be sent to you free of charge; it is quick and easy to assemble.\n\nFollowing the collection of your information, we will contact you within a maximum of 20 days to confirm when your repair kit will be available. Please be aware that every effort will be made to reduce these delays to satisfy you',
    'kitLabel': 'Full repair kit',
    'docLabel': 'Repair instructions',
    'callToAction': 'Click here to receive your free repair kit',
    'infoConfirmation': 'Please check your details',
    'validateConfirmation': 'Validate',
    'backConfirmation': 'Back'
  },
  'repairRequest': {
    'title': 'Please enter the following information to receive your repair kit:'
  },
  'form': {
    'submit': 'Next'
  },
  'status': 'Translation validated by SPORT'
} as const
